import { createRouter } from "@tanstack/react-router";
import { routeTree } from "@/routeTree.gen";
import { appHistory } from "@/common/other/appHistory";
import PageNotFound from "@/common/components/views/PageNotFound";

// Create a new router instance
export const router = createRouter({
  routeTree,
  context: {
    currentUser: undefined,
  },
  history: appHistory,
  defaultNotFoundComponent: PageNotFound,
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
